import t from 'tcomb';
import Text_Style from './style/Text_Style';

const Position = t.enums.of([
  'left',
  'right'
], 'Position'); //FIXME  PORTARE FUORI

const Valign = t.enums.of([
  'top',
  'middle',
  'bottom'
], 'Valign'); //FIXME  PORTARE FUORI

const Text = t.struct({
  style: Text_Style,
  value: t.Str,  //ex.markdown
  position: t.maybe(Position),
  valign: t.maybe(Valign)
}, 'Text');

export default Text;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Text.js
 **/